import React from 'react';
import { Button } from '@gumtree/ui-library';
import { ButtonsContainer, Spinner, ButtonTitle, ButtonCss } from './message-buttons.style';

export const MessageButtons: React.FC<MessageButtonsProps> = ({
    replyPhone,
    callDisabled,
    messageDisabled,
    onSendMessageClick,
    onCallClick,
    sendState,
    className,
}) => {
    return (
        <ButtonsContainer className={className}>
            {replyPhone && (
                <div>
                    <Button
                        type="button"
                        fullWidth
                        display="secondary"
                        data-q="call-button"
                        label="Call"
                        disabled={callDisabled}
                        onClick={onCallClick}
                        css={ButtonCss}
                    />
                </div>
            )}
            <Spinner spinning={sendState === 'sending'}>
                <Button
                    type="button"
                    display="primary"
                    fullWidth
                    css={ButtonCss}
                    disabled={messageDisabled}
                    data-q="send-message-button"
                    label={
                        <>
                            <div className="loader-spinner" />
                            <ButtonTitle>Send message</ButtonTitle>
                        </>
                    }
                    onClick={onSendMessageClick}
                />
            </Spinner>
        </ButtonsContainer>
    );
};

export interface MessageButtonsProps {
    className?: string;
    replyPhone: boolean;
    callDisabled: boolean;
    messageDisabled: boolean;
    onSendMessageClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
    onCallClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
    sendState: 'unsent' | 'sending' | 'sent';
}
